<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">播单管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="节目单名称" prop="name">
            <el-input v-model="name" placeholder="请输入节目单名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="播放状态">
            <el-select v-model="playStatus" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in broadcastStatueArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="发布状态">
            <el-select v-model="publishStatus" placeholder="请选择">
              <el-option key label="全部" :value="null"></el-option>
              <el-option
                v-for="item in publishStatueArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="name" label="播单名称"></el-table-column>
              <el-table-column
                prop="beginDate"
                label="播放日期"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.beginDate != null"
                    >{{ scope.row.beginDate }}至{{
                      scope.row.endDate
                    }}</span
                  >
                  <span v-else>-</span>
                </template></el-table-column
              >
              <el-table-column prop="beginTime" label="播放时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.beginTime != null"
                    >{{ scope.row.beginTime }}至{{
                      scope.row.endTime
                    }}</span
                  >
                  <span v-else>-</span>
                </template></el-table-column
              >
              <!-- <el-table-column prop="playStatus" label="播放状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.playStatus == 1">正在播放</span>
                  <span v-else-if="scope.row.playStatus == 0">未播放</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="publishStatusTranslated" label="是否发布">
                <!-- <template slot-scope="scope">
                  <span v-if="scope.row.publishStatus == '1'">未发布</span>
                  <span v-if="scope.row.publishStatus == '2'">已发布</span>
                </template> -->
              </el-table-column>
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <template>
                    <!-- <el-button
                      @click="offPlay(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="
                        scope.row.IsPlaying == 1 && scope.row.IsPublished == 1
                      "
                      >暂停播放</el-button
                    >
                    <el-button
                      @click="startPlay(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="
                        scope.row.IsPlaying == 0 && scope.row.IsPublished == 1
                      "
                      >启动播放</el-button
                    > -->
                    <el-button
                      @click="startBrodcastOrder(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="scope.row.publishStatus == '2'"
                      >发布</el-button
                    >
                    <el-button
                      @click="stopBrodcastOrder(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="scope.row.publishStatus == '1'"
                      >停止</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { startBroadcastTask, stopBroadcastTask,BroadcastList,BroadcastDel,startOrder,stopOrder } from "@/api/src/broadcast";
export default {
  name: "BroadcastListView",
  controller: "UI",
  action: "BroadcastListView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      name: null,
      publishStatus: null,
      playStatus: null,
      publishStatueArr: [
        { value: 1, label: "已发布" },
        { value: 2, label: "未发布" },
      ],
      broadcastStatueArr: [
        { value: 1, label: "正在播放" },
        { value: 0, label: "未播放" },
      ],
      loading: false,
      loadingText: "",
    };
  },
  created: function () {},
  mounted: function () {
    this.search();
    // this.logInfo.ActionName = "播单管理信息查询";
    // this.logInfo.LogMessage = "播单管理信息查询";
    // this.logInfo.ModuleName = "广播系统";
    // this.logInfo.PageName = "播单管理列表页";
    // this.addOperationLog();
  },
  methods: {
    startBrodcastOrder(index, row){
      let params={
        taskId:row.id
      }
      // this.loading = true;
      // this.loadingText = "加载中...";
      startOrder(params).then(res=>{
        console.log(res)
        this.loading = false;
        if(res.code==200){
          this.$message({
            type: "success",
            message: "发布成功!",
          });
          this.search();
        }
      })
    },
    stopBrodcastOrder(index, row){
      let params={
        taskId:row.id
      }
      // this.loading = true;
      // this.loadingText = "加载中...";
      stopOrder(params).then(res=>{
        this.loading = false;
        if(res.code==200){
          this.$message({
            type: "success",
            message: "停止成功!",
          });
          this.search();
        }
      })
    },
    search() {
      this.loading = true;
      this.loadingText = "加载中...";
      let searchInfo = {
        name: this.name,
        // playStatus:this.playStatus,
        publishStatus: this.publishStatus,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      BroadcastList(searchInfo).then(res=>{
        console.log("播单列表")
        console.log(res)
        this.loading = false;
        if(res.code==200){
          this.tableData = res.rows;
          this.total = res.total;
        }else{
          this.tableData = [];
          this.total = 0;
        }
      })
      // new MyApis.TaskApi()
      //   .GetPageContentByConditions(searchInfo)
      //   .then((r) => {
      //     r = r.data.Data;
      //     this.tableData = r.PageContents;
      //     this.total = r.BaseSearch.TotalCount;
      //     if (r && this.tableData.length > 0) {
      //       this.tableData.map((item2) => {
      //         item2.TaskPlanList.map((item1) => {
      //           if (item2.TaskId === item1.TaskId) {
      //             let json = {
      //               PlanStartDate:
      //                 item1.PlanStartDate == null ||
      //                 item1.PlanStartDate == "0001-01-01T00:00:00"
      //                   ? null
      //                   : new Date(item1.PlanStartDate).format("yyyy-MM-dd"),
      //               PlanEndDate:
      //                 item1.PlanEndDate == null ||
      //                 item1.PlanEndDate == "0001-01-01T00:00:00"
      //                   ? null
      //                   : new Date(item1.PlanEndDate).format("yyyy-MM-dd"),
      //               PlanStartTime:
      //                 item1.PlanStarTime == null ||
      //                 item1.PlanStarTime == "0001-01-01T00:00:00"
      //                   ? null
      //                   : new Date(item1.PlanStarTime).format("hh:mm:ss"),

      //               PlanEndTime:
      //                 item1.PlanEndTime == null ||
      //                 item1.PlanEndTime == "0001-01-01T00:00:00"
      //                   ? null
      //                   : new Date(item1.PlanEndTime).format("hh:mm:ss"),
      //             };
      //             Object.assign(item2, json);
      //             return item2;
      //           }
      //         });
      //       });
      //     }
      //     this.loading = false;
      //   })
      //   .catch((e) => {
      //     this.loading = false;
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/broadcast/UI/BroadcastListInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/BroadcastListInfo",
        query: { InfoId: row.TaskId, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      if (row.IsPlaying == 1) {
        this.$message.warning("该播单正在播放，无法编辑，请先停止播放");
        return;
      }
      this.$router.push({
        path: "/plugin/broadcast/ui/BroadcastListInfo",
        query: { id: row.id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      if (row.IsPlaying == 1) {
        this.$message.warning("该播单正在播放，无法删除，请先停止播放");
        return;
      }
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          BroadcastDel({ id: row.id }).then(res=>{
            console.log("del",res)
            if(res.code==200){
              this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.search();
            }else{
              this.$message({
                  type: "error",
                  message: "删除失败!",
                });
            }
          })
          // new MyApis.TaskApi()
          //   .DelItem({ Id: row.TaskId })
          //   .then((r) => {
          //     r = r.data.Data;
          //     if (r) {
          //       this.$message({
          //         type: "success",
          //         message: "删除成功!",
          //       });
          //     } else {
          //       this.$message({
          //         type: "error",
          //         message: "删除失败!",
          //       });
          //     }
          //     this.logInfo.ActionName = "播单管理信息删除";
          //     this.logInfo.LogMessage = r
          //       ? "播单管理信息删除成功"
          //       : "播单管理信息删除失败";
          //     this.logInfo.ModuleName = "广播系统";
          //     this.logInfo.PageName = "播单管理列表页";
          //     this.addOperationLog();
          //     this.search();
          //   })
          //   .catch((e) => {
          //     console.log(e);
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Name = null;
      this.publishStatue = "";
      this.playStatue = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //行删除
    updateTask(row) {
      new MyApis.TaskApi()
        .UpdateItem(row)
        .then((r) => {
          r = r.data.Data;

          this.logInfo.ActionName =
            row.IsPlaying == 1 ? "播单启动播放" : "播单停止播放";
          this.logInfo.LogMessage =
            row.IsPlaying == 1 ? "播单启动播放成功" : "播单停止播放成功";
          this.logInfo.ModuleName = "广播系统";
          this.logInfo.PageName = "播单管理列表页";
          this.addOperationLog();
          // this.search();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDetail(row) {
      if (row.TaskId) {
        new MyApis.TaskApi()
          .GetItemById({ id: row.TaskId })
          .then((r) => {
            r = r.data.Data;

            if (r.TaskProgramList.length == 0) {
              this.$message.warning("请先选择播放节目");
              return;
            }
            if (r.TaskDeviceList.length == 0) {
              this.$message.warning("请先选择播放终端");
              return;
            }

            let updateModel = row;
            startBroadcastTask({
              data: { taskId: row.TaskId },
              baseUrl: global.$config.api.apiUrl,
            })
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    type: "success",
                    message: "启动播放成功",
                  });
                  this.logInfo.ActionName = "播单启动播放";
                  this.logInfo.LogMessage = "播单启动播放成功";
                  this.logInfo.ModuleName = "广播系统";
                  this.logInfo.PageName = "播单管理列表页";
                  this.addOperationLog();
                  updateModel.IsPlaying = 1;
                  this.search();
                  //  this.updateTask(updateModel);
                } else {
                  this.$message({
                    type: "error",
                    message: "启动播放失败",
                  });
                }
              })
              .catch((e) => {
                this.$message({
                  type: "error",
                  message: "启动播放失败",
                });
              });
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    startPlay(index, row) {
      if (!row.PlanEndDate) {
        this.$message.warning("请先选择播放日期");
        return;
      }
      if (!row.PlanEndTime) {
        this.$message.warning("请先选择播放时间");
        return;
      }

      if (new Date(row.PlanEndDate + " " + row.PlanEndTime) < new Date()) {
        this.$message.warning("计划播放结束时间应该大于当前时间");
        return;
      }
      this.getDetail(row);
    },
    offPlay(index, row) {
      let updateModel = row;

      stopBroadcastTask({
        data: { taskId: row.TaskId },
        baseUrl: global.$config.api.apiUrl,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "播放停止成功",
            });
            this.logInfo.ActionName = "播单停止播放";
            this.logInfo.LogMessage = "播单停止播放成功";
            this.logInfo.ModuleName = "广播系统";
            this.logInfo.PageName = "播单管理列表页";
            this.addOperationLog();
            updateModel.IsPlaying = 0;
            this.search();
            //this.updateTask(updateModel);
          } else {
            this.$message({
              type: "error",
              message: "播放停止失败",
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: "播放停止失败",
          });
        });
    },
  },
};
</script>
